/* 

  HEADS UP! THIS IS A GENERATED FILE!
  
  Changes done in this file will be overwritten on next generation from the code generator.

*/
import {
  DateRangePicker,
  NumberFilterInput,
  PipeStringFilter,
} from 'components/filters';
import { OrderFullfillmentCenterSelect } from 'components/Selects';
import {
  LabelInput,
  SecureFormsy,
  Select,
} from 'flaivy-react/components/inputs';
/* eslint-enable */
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import {
  Button,
  ButtonGroup,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';

// eslint-disable-next-line
async function resolveQuery(query) {
  const resolvedQuery = { ...query };
  // eslint-disable-next-line
  return resolvedQuery;
}

const defaultActionValues = () => ({});

function SupplierCustomerFilterPanel({
  querySpecification,
  onChange,
  isSubForm,
  isModal,
  // eslint-disable-next-line
  immutableQuery,
}) {
  const [state, setState] = useState({
    querySpecification,
  });

  useEffect(() => {
    async function getResolvedQuery() {
      const fullyResolvedFilter = await resolveQuery(querySpecification || []);
      setState({
        querySpecification: {
          ...(querySpecification || defaultActionValues()),
        },
        resolvedQuery: {
          ...(fullyResolvedFilter || defaultActionValues()),
        },
      });
    }
    if (querySpecification) {
      getResolvedQuery();
    }
    /* eslint-disable-next-line */
  }, []);

  /* eslint-disable-next-line */
  const handleChange = async (key, value) => {
    const { querySpecification, resolvedQuery } = state;

    const newQuerySpecification = { ...querySpecification };
    const newResolvedQuery = { ...resolvedQuery };

    const isEmptyChild =
      (Array.isArray(value) && value.length === 0) ||
      (_.isObject(value) && (_.isEmpty(value) || value.iLike === '%'));

    const isEmptyValue =
      value === null ||
      value === undefined ||
      value === '' ||
      value === '<NULL>' ||
      value === '%' ||
      isEmptyChild;
    if (isEmptyValue) {
      delete newQuerySpecification[key];
      delete newResolvedQuery[key];
    } else {
      newQuerySpecification[key] = value;
      newResolvedQuery[key] = value;
    }

    setState({
      querySpecification: newQuerySpecification,
      resolvedQuery: newResolvedQuery,
    });
    // eslint-disable-next-line
    await onChange(newQuerySpecification);
  };

  const reset = async () => {
    setState({
      querySpecification: { ...immutableQuery },
      resolvedQuery: {},
    });
    // eslint-disable-next-line
    await onChange({});
  };

  /* eslint-disable no-unused-vars */
  const { resolvedQuery } = state;
  /* eslint-enable */

  return (
    <>
      <SecureFormsy isSubForm={isSubForm}>
        {!isModal && (
          <Button onClick={reset} className="my-2" color="secondary" block>
            Rensa filter
          </Button>
        )}

        {typeof immutableQuery.orderFullfillmentCenter === 'undefined' && (
          <FormGroup>
            <Label>Lagerställe</Label>
            <OrderFullfillmentCenterSelect
              defaultOptions={false}
              instanceId="select-orderFullfillmentCenter"
              name="orderFullfillmentCenter"
              value={_.get(resolvedQuery, 'orderFullfillmentCenter')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.customerNumber === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.currency === 'undefined' && (
          <FormGroup>
            <Label>Valuta</Label>
            <Select
              instanceId="select-currency"
              name="currency"
              value={_.get(resolvedQuery, 'currency', '')}
              onChange={handleChange}
              options={[
                { value: 'SEK', label: 'SEK' },
                { value: 'NOK', label: 'NOK' },
                { value: 'DKK', label: 'DKK' },
              ]}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.name === 'undefined' && <FormGroup></FormGroup>}

        {typeof immutableQuery.restaurantNumber === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.organisationNumber === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.VATNumber === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.deliveryCountry === 'undefined' && (
          <FormGroup>
            <Label>Land</Label>
            <Select
              type="string"
              instanceId="select-deliveryCountry"
              name="deliveryCountry"
              value={_.get(resolvedQuery, 'deliveryCountry')}
              onChange={handleChange}
              options={[
                { label: 'Sverige', value: 'SE' },
                { label: 'Finland', value: 'FI' },
                { label: 'Norge', value: 'NO' },
                { label: 'Danmark', value: 'DK' },
                { label: 'Island', value: 'IS' },
                { label: 'Alla', value: undefined },
              ]}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.chain === 'undefined' && (
          <FormGroup>
            <Label>Kedja</Label>
            <PipeStringFilter
              name="chain"
              value={_.get(resolvedQuery, 'chain')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.customerType === 'undefined' && (
          <FormGroup>
            <Label>Kundtyp</Label>
            <Select
              type="string"
              instanceId="select-customerType"
              name="customerType"
              value={_.get(resolvedQuery, 'customerType')}
              onChange={handleChange}
              options={[
                { label: 'HoReCa', value: 'horeca' },
                { label: 'Dagligvaruhandel', value: 'dvh' },
                { label: 'Grossist', value: 'wholesale' },
                { label: 'Kontor', value: 'office' },
                { label: 'Systembolaget', value: 'systembolaget' },
                { label: 'Leverantör till Flaivy', value: 'supplier' },
                { label: 'Export', value: 'export' },
                { label: 'Övrigt', value: 'other' },
                { label: 'Alla', value: undefined },
              ]}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.yourReference === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.email === 'undefined' && <FormGroup></FormGroup>}

        {typeof immutableQuery.invoiceDeliveryType === 'undefined' && (
          <FormGroup>
            <Label>Fakturaleveranssätt</Label>
            <Select
              instanceId="select-invoiceDeliveryType"
              name="invoiceDeliveryType"
              value={_.get(resolvedQuery, 'invoiceDeliveryType', '')}
              onChange={handleChange}
              options={[
                { value: 'PRINT', label: 'Utskrift' || 'PRINT' },
                { value: 'EMAIL', label: 'E-post' || 'EMAIL' },
                {
                  value: 'ELECTRONICINVOICE',
                  label: 'E-faktura' || 'ELECTRONICINVOICE',
                },
                { label: 'Alla', value: undefined },
              ]}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.emailInvoice === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.phone === 'undefined' && <FormGroup></FormGroup>}

        {typeof immutableQuery.active === 'undefined' && (
          <FormGroup>
            <Label>Aktiverad</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={_.get(resolvedQuery, 'active') === undefined}
                onClick={() => {
                  handleChange('active', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'active') === true ||
                  _.get(resolvedQuery, 'active') === 'true'
                }
                onClick={() => {
                  handleChange('active', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'active') === false ||
                  _.get(resolvedQuery, 'active') === 'false'
                }
                onClick={() => {
                  handleChange('active', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.GLN === 'undefined' && <FormGroup></FormGroup>}

        {typeof immutableQuery.GLNBY === 'undefined' && <FormGroup></FormGroup>}

        {typeof immutableQuery.GLNIV === 'undefined' && <FormGroup></FormGroup>}

        {typeof immutableQuery.GLNCN === 'undefined' && <FormGroup></FormGroup>}

        {typeof immutableQuery.GLNDP === 'undefined' && <FormGroup></FormGroup>}

        {typeof immutableQuery.GLNSU === 'undefined' && <FormGroup></FormGroup>}

        {typeof immutableQuery.invoiceAddress === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.invoiceAddress2 === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.invoiceZipCode === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.invoiceCity === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.approvedCustomer === 'undefined' && (
          <FormGroup>
            <Label>Godkänd kund</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={_.get(resolvedQuery, 'approvedCustomer') === undefined}
                onClick={() => {
                  handleChange('approvedCustomer', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'approvedCustomer') === true ||
                  _.get(resolvedQuery, 'approvedCustomer') === 'true'
                }
                onClick={() => {
                  handleChange('approvedCustomer', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'approvedCustomer') === false ||
                  _.get(resolvedQuery, 'approvedCustomer') === 'false'
                }
                onClick={() => {
                  handleChange('approvedCustomer', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.blocked === 'undefined' && (
          <FormGroup>
            <Label>Kund har köpstopp</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={_.get(resolvedQuery, 'blocked') === undefined}
                onClick={() => {
                  handleChange('blocked', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'blocked') === true ||
                  _.get(resolvedQuery, 'blocked') === 'true'
                }
                onClick={() => {
                  handleChange('blocked', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'blocked') === false ||
                  _.get(resolvedQuery, 'blocked') === 'false'
                }
                onClick={() => {
                  handleChange('blocked', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.blockedReason === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.requiresGroupInvoice === 'undefined' && (
          <FormGroup>
            <Label>Samlingsfaktura</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'requiresGroupInvoice') === undefined
                }
                onClick={() => {
                  handleChange('requiresGroupInvoice', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'requiresGroupInvoice') === true ||
                  _.get(resolvedQuery, 'requiresGroupInvoice') === 'true'
                }
                onClick={() => {
                  handleChange('requiresGroupInvoice', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'requiresGroupInvoice') === false ||
                  _.get(resolvedQuery, 'requiresGroupInvoice') === 'false'
                }
                onClick={() => {
                  handleChange('requiresGroupInvoice', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.contractualCustomer === 'undefined' && (
          <FormGroup>
            <Label>Avtalkund</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'contractualCustomer') === undefined
                }
                onClick={() => {
                  handleChange('contractualCustomer', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'contractualCustomer') === true ||
                  _.get(resolvedQuery, 'contractualCustomer') === 'true'
                }
                onClick={() => {
                  handleChange('contractualCustomer', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'contractualCustomer') === false ||
                  _.get(resolvedQuery, 'contractualCustomer') === 'false'
                }
                onClick={() => {
                  handleChange('contractualCustomer', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.isBlockedFromCampaigns === 'undefined' && (
          <FormGroup>
            <Label>Kunden är blockad från att ta del av kampanjer</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'isBlockedFromCampaigns') === undefined
                }
                onClick={() => {
                  handleChange('isBlockedFromCampaigns', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'isBlockedFromCampaigns') === true ||
                  _.get(resolvedQuery, 'isBlockedFromCampaigns') === 'true'
                }
                onClick={() => {
                  handleChange('isBlockedFromCampaigns', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'isBlockedFromCampaigns') === false ||
                  _.get(resolvedQuery, 'isBlockedFromCampaigns') === 'false'
                }
                onClick={() => {
                  handleChange('isBlockedFromCampaigns', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.invoiceCountry === 'undefined' && (
          <FormGroup>
            <Label>Fakturaadress land</Label>
            <Select
              type="string"
              instanceId="select-invoiceCountry"
              name="invoiceCountry"
              value={_.get(resolvedQuery, 'invoiceCountry')}
              onChange={handleChange}
              options={[
                { label: 'Sverige', value: 'SE' },
                { label: 'Finland', value: 'FI' },
                { label: 'Norge', value: 'NO' },
                { label: 'Danmark', value: 'DK' },
                { label: 'Island', value: 'IS' },
                { label: 'Alla', value: undefined },
              ]}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.deliveryName === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.deliveryAddress === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.deliveryAddress2 === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.deliveryZipCode === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.deliveryCity === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.deliveryPhone === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.deliveryGLN === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.hasAlcoholPermit === 'undefined' && (
          <FormGroup>
            <Label>Har bekräftat alkoholtillstånd</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={_.get(resolvedQuery, 'hasAlcoholPermit') === undefined}
                onClick={() => {
                  handleChange('hasAlcoholPermit', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'hasAlcoholPermit') === true ||
                  _.get(resolvedQuery, 'hasAlcoholPermit') === 'true'
                }
                onClick={() => {
                  handleChange('hasAlcoholPermit', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'hasAlcoholPermit') === false ||
                  _.get(resolvedQuery, 'hasAlcoholPermit') === 'false'
                }
                onClick={() => {
                  handleChange('hasAlcoholPermit', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.minOrderValue === 'undefined' && (
          <FormGroup>
            <Label>Minsta ordervärde för kund</Label>
            <NumberFilterInput
              name="minOrderValue"
              value={_.get(resolvedQuery, 'minOrderValue')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.isPossibleToPlaceOrderBelowOrderMinimum ===
          'undefined' && (
          <FormGroup>
            <Label>
              Det är möjligt för kund att lägga order under kollikrav eller
              minsta ordervärde mot en ev.avgift.
            </Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={
                  _.get(
                    resolvedQuery,
                    'isPossibleToPlaceOrderBelowOrderMinimum',
                  ) === undefined
                }
                onClick={() => {
                  handleChange(
                    'isPossibleToPlaceOrderBelowOrderMinimum',
                    undefined,
                  );
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(
                    resolvedQuery,
                    'isPossibleToPlaceOrderBelowOrderMinimum',
                  ) === true ||
                  _.get(
                    resolvedQuery,
                    'isPossibleToPlaceOrderBelowOrderMinimum',
                  ) === 'true'
                }
                onClick={() => {
                  handleChange('isPossibleToPlaceOrderBelowOrderMinimum', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(
                    resolvedQuery,
                    'isPossibleToPlaceOrderBelowOrderMinimum',
                  ) === false ||
                  _.get(
                    resolvedQuery,
                    'isPossibleToPlaceOrderBelowOrderMinimum',
                  ) === 'false'
                }
                onClick={() => {
                  handleChange(
                    'isPossibleToPlaceOrderBelowOrderMinimum',
                    false,
                  );
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.minCollisOnOrder === 'undefined' && (
          <FormGroup>
            <Label>Minsta antal kollin för kund på order</Label>
            <NumberFilterInput
              name="minCollisOnOrder"
              value={_.get(resolvedQuery, 'minCollisOnOrder')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.kegCountsAsNCollis === 'undefined' && (
          <FormGroup>
            <Label>
              Hur många kollin varje fat räknas som på en order för kund
            </Label>
            <NumberFilterInput
              name="kegCountsAsNCollis"
              value={_.get(resolvedQuery, 'kegCountsAsNCollis')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.deliveryBreakpointText === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.deliveryRules === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.labels === 'undefined' && (
          <FormGroup>
            <Label>Etiketter</Label>
            <LabelInput
              instanceId="select-labels"
              name="labels"
              value={_.get(resolvedQuery, 'labels')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.owningSupplierOrganizationId === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.termsOfPayment === 'undefined' && (
          <FormGroup>
            <Label>Betalningsvillkor</Label>
            <Select
              type="string"
              instanceId="select-termsOfPayment"
              name="termsOfPayment"
              value={_.get(resolvedQuery, 'termsOfPayment')}
              onChange={handleChange}
              options={[
                { label: '0 dagar', value: '0' },
                { label: '10 dagar', value: '10' },
                { label: '15 dagar', value: '15' },
                { label: '20 dagar', value: '20' },
                { label: '30 dagar', value: '30' },
                { label: '35 dagar', value: '35' },
                { label: '60 dagar', value: '60' },
                { label: '70 dagar', value: '70' },
                { label: 'Autogiro', value: 'A' },
                { label: 'Kontant', value: 'K' },
                { label: 'Postförskott', value: 'PF' },
                { label: 'Alla', value: undefined },
              ]}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.exciseNumber === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.taxWarehouseNumber === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.customFields === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.supplierCustomerContacts === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.createdAt === 'undefined' && (
          <FormGroup>
            <Label>Skapad</Label>
            <DateRangePicker
              name="createdAt"
              value={_.get(resolvedQuery, 'createdAt')}
              onChange={handleChange}
            />
          </FormGroup>
        )}
        {typeof immutableQuery.updatedAt === 'undefined' && (
          <FormGroup>
            <Label>Uppdaterad</Label>
            <DateRangePicker
              name="updatedAt"
              value={_.get(resolvedQuery, 'updatedAt')}
              onChange={handleChange}
            />
          </FormGroup>
        )}
      </SecureFormsy>
      {isModal && (
        <Button onClick={reset} className="mt-3">
          Rensa filter
        </Button>
      )}
    </>
  );
}

SupplierCustomerFilterPanel.propTypes = {
  querySpecification: PropTypes.object,
  immutableQuery: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  isSubForm: PropTypes.bool,
  isModal: PropTypes.bool,
};

SupplierCustomerFilterPanel.defaultProps = {
  querySpecification: defaultActionValues(),
  immutableQuery: {},
  isSubForm: false,
  isModal: false,
};

function SupplierCustomerFilterPanelModal({
  onSubmit,
  querySpecification,
  immutableQuery,
}) {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const handleChange = newQuerySpecification => {
    onSubmit(newQuerySpecification);
  };

  const applyFilters = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Modal toggle={toggle} isOpen={isOpen} centered scrollable>
        <ModalHeader toggle={toggle}>Filtrera</ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <SupplierCustomerFilterPanel
                onChange={handleChange}
                querySpecification={querySpecification}
                immutableQuery={immutableQuery}
                isModal
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Row>
            <Col>
              <Button
                onClick={applyFilters}
                color="primary"
                className="float-end mt-3"
              >
                Stäng
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
      <Button color="outline-secondary" onClick={toggle}>
        Filtrera
      </Button>
    </>
  );
}

SupplierCustomerFilterPanelModal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  querySpecification: PropTypes.object,
  immutableQuery: PropTypes.object,
};

SupplierCustomerFilterPanelModal.defaultProps = {
  querySpecification: null,
  immutableQuery: {},
};

module.exports = {
  SupplierCustomerFilterPanel,
  SupplierCustomerFilterPanelModal,
};
